import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";

@Component({
  selector: "common-drag-drop-file-upload",
  templateUrl: "./drag-drop-file-upload.component.html",
  styleUrls: ["./drag-drop-file-upload.component.scss"],
})
export class DragDropFileUploadComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;

  @Input() acceptedFileTypes: string = ".pdf, .doc, .docx, .png, .jpg, .jpeg";
  /**
   * Override the main drop-zone prompt. Defaults to a generic "Drop file here..." message;
   * photo-upload flows (e.g. earnings-calculator, machine onboarding wizard) override
   * this to "Open camera or browse for picture".
   */
  @Input() dropPrompt: string = "Drop file here or click to select file";
  /** When true, the accepted file extensions are shown below the main prompt. */
  @Input() showAcceptedFileTypes: boolean = true;
  /** Icon class shown in the drop zone (e.g. icon-camera for photo uploads). */
  @Input() dropZoneIconClass: string = "icon-stepper-add";

  file: File;
  fileOver: boolean;

  @Output() fileChange = new EventEmitter<File>();

  // Dragover listener
  @HostListener("dragover", ["$event"]) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  // Dragleave listener
  @HostListener("dragleave", ["$event"]) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
  }

  // Drop listener
  @HostListener("drop", ["$event"]) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileSelect(files);
      console.log(files);
    }
  }

  constructor() {}

  ngOnInit(): void {}

  dropZoneClick() {
    this.fileInput.nativeElement.click();
  }

  onFileSelect(files: File[]) {
    if (files.length == 0) {
      return;
    }

    if (files.length > 1) {
      alert("Only one file is required.");
      return;
    }

    this.file = files[0];
    this.fileChange.emit(this.file);
  }

  deleteFile() {
    this.file = null;
    this.fileChange.emit(this.file);
  }
}
